export const FEATURE_ACCESS_SEGMENT = "/access";

export const FeatureSegments = {
    compensation: "/features/compensation",
    engagement: "/features/engagement",
    goals: "/features/goals",
    "good-vibes": "/features/good-vibes",
    meetings: "/features/meetings",
    "org-chart": "/features/org-chart",
    "performance-reviews": "/features/performance-reviews",
    plans: "/features/plans"
} as const;
